import { defineMessages } from 'react-intl';

export const messages: {
	carouselMacroDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	carouselMacroTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	carouselMacroTitleUpdated: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	carouselMacroTitle: {
		id: 'company-hub.carousel-extension.manifest.macro-title',
		defaultMessage: 'Carousel',
		description: 'Title of carousel macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	carouselMacroTitleUpdated: {
		id: 'company-hub.carousel-extension.manifest.macro-title.updated',
		defaultMessage: 'Carousel',
		description:
			'Title of carousel macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	carouselMacroDescription: {
		id: 'company-hub.carousel-extension.manifest.macro-description',
		defaultMessage: 'Create a rotating trio of dynamic frames.',
		description:
			'Description of carousel macro to be displayed in toolbar/shortcut macros dropdown',
	},
});
